import _BaseAPIService from "../_BaseAPIService";

const instance = _BaseAPIService.instance;
export const RestroUserQueryLogsData = {
  getAll: async ({tenantCode}) => {
    try {
      const params = new URLSearchParams();
      console.log(params)
       if (tenantCode) params.append("tenantCode", tenantCode);
      const response = await instance.get(`/restrousersquerylogs/list?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error( error);
      throw error;
    }
  },
  getAllStats: async () => {
    try {
//       console.log(IsActive)
//       const params = new URLSearchParams();
//       if (tenantName) params.append("tenantName", tenantName);
//       if (tenantCode) params.append("tenantCode", tenantCode);
//       if (IsActive !== null && IsActive !== undefined) {
//   params.append("IsActive", IsActive ? "true" : "false");
// }
      const response = await instance.get(`/restrousersquerylogs/statistics`);
      return response;
    } catch (error) {
      console.error( error);
      throw error;
    }
  },
  getByApiKey: async(apiKey)=>{
     try{
      const response = await instance.get(`/restrousersinfo/apikey/${apiKey}`)
      return response.data;
    }catch(err){
      console.error(err)
      throw err;
    }
  }

  }